import * as React from "react";
import { INotificationProps, INotificationState } from "./Notification.types";
import { Icon } from "../Icon/icon";

/**
 * Renders a notification bar. The color is defined by _props.notificationType_
 */
export class Notification extends React.Component<
  INotificationProps,
  INotificationState
> {
  static defaultProps = {
    onCloseCallback: () => {},
  };
  constructor(props: INotificationProps) {
    super(props);
    this.state = {
      show: true,
    };
  }

  close = () => {
    this.setState(
      {
        show: false,
      },
      () => this.props.onCloseCallback()
    );
  };

  render() {
    return (
      this.state.show && (
        <div
          className={`notification notification--${this.props.notificationType}`}
        >
          <div className="notification__status" role="alert">
            {" "}
            {this.props.notificationText}
          </div>
          <button
            aria-label="Stäng notisen"
            type="button"
            className="close"
            onClick={this.close}
          >
            <Icon
              isAriaHidden={false}
              ariaLabel="Stäng"
              iconType="ic_close_white_24px"
            />
          </button>
        </div>
      )
    );
  }
}
